export class SupplierManagementToken {
  static ISupplierManagementRepository = Symbol(
    "ISupplierManagementRepository",
  );
  static SupplierManagementUseCase = Symbol("SupplierManagementUseCase");
  static SupplierManagementViewModel = Symbol("SupplierManagementViewModel");
}
